import $ from 'jquery'
import { lockScreen, unlockScreen } from '../modules/screenLocker'
import { isSP } from '../modules/checkScreen'

const $dropdownButton = $('.js-works-dropdown')
const $boxKeyword = $('.c-box-list-keyword')
const OPEN_CLASS = 'is-active'

const dropDown = () => {
  if ($dropdownButton.length) {
    $dropdownButton.on('click', () => {
      $dropdownButton.toggleClass(OPEN_CLASS)
      $boxKeyword.toggleClass(OPEN_CLASS)
      $boxKeyword.slideToggle()
      return false
    })
  }
}

const initWorks = () => {
  dropDown()
}

export default initWorks
